import { FeaturePageCitations } from "@/features/feature-page/feature-page-citations";
import { FeaturePageSection } from "@/features/feature-page/feature-page-section";
import type { ResolvedFeaturePageBlock } from "@garimpa/api/featurePages/types";

export function RichTextBlock({
  block,
}: {
  block: Extract<ResolvedFeaturePageBlock, { type: "richText" }>;
}) {
  const firstParagraphHeadingIndex = block.paragraphs.findIndex((paragraph) => paragraph.heading);
  const fallbackHeadingId =
    !block.heading && firstParagraphHeadingIndex >= 0 ? `${block.id}-heading` : undefined;
  return (
    <FeaturePageSection
      block={block}
      resolvedBackground={block.resolvedBackground}
      labelledById={fallbackHeadingId}
    >
      {block.heading ? (
        <h2
          id={`${block.id}-heading`}
          className="mb-8 text-center text-3xl font-bold tracking-tight sm:text-5xl"
        >
          {block.heading}
        </h2>
      ) : null}
      <div className="space-y-8 text-lg leading-8 text-foreground/80">
        {block.paragraphs.map((paragraph, index) => {
          const ParagraphHeading = block.heading ? "h3" : "h2";
          return (
            <div key={`${block.id}-${index}`}>
              {paragraph.heading ? (
                <ParagraphHeading
                  id={index === firstParagraphHeadingIndex ? fallbackHeadingId : undefined}
                  className="mb-3 text-2xl font-bold text-foreground"
                >
                  {paragraph.heading}
                </ParagraphHeading>
              ) : null}
              <p>
                {paragraph.text}
                <FeaturePageCitations sourceIds={paragraph.sourceIds} />
              </p>
            </div>
          );
        })}
      </div>
    </FeaturePageSection>
  );
}
